/* eslint-disable graphql/template-strings */
/* eslint-disable max-len */
import { Injectable } from '@angular/core';
import { DocumentNode } from 'graphql';
import * as apollo from 'apollo-link';
import { gql } from 'graphql-tag';
import { filter, first } from 'rxjs/operators';
import {
  ConnextConfig,
} from '..';

import { GraphqlApiService } from '../../graphql-api/graphql-api.service';

export interface UpdateConfigInConnextInput {
  deviceId: string;
  configVerified?: boolean;
  remove?: boolean;
}
const build = (_query: DocumentNode, input: UpdateConfigInConnextInput, name = 'QueryResult') => {
  const bQuery = `
  mutation ${ name }(`+
    ( input.deviceId !== undefined ? `$deviceId: String = ${JSON.stringify(input.deviceId).replace(/"(\w+)":/g, '$1:')}, ` : '' ) + ``+
    ( input.configVerified !== undefined ? `$configVerified: Boolean = ${JSON.stringify(input.configVerified).replace(/"(\w+)":/g, '$1:')}, ` : '' ) + ``+
    ( input.remove !== undefined ? `$remove: Boolean = ${JSON.stringify(input.remove).replace(/"(\w+)":/g, '$1:')}` : '' ) + `){
    updateConfigInConnext(
      ${ input.deviceId !== undefined ? 'deviceId: $deviceId,' : '' } 
      ${ input.configVerified !== undefined ? 'configVerified: $configVerified,' : '' } 
      ${ input.remove !== undefined ? 'remove: $remove,' : '' }
    ){
      ...connextconfig
    }
  }`;
  return gql`
  ${bQuery}
  ${_query}
`};

@Injectable({
  providedIn: 'root',
})
export class UpdateConfigInConnextMutation {
  readonly graphqlClient$ = this.graphqlApiService.client$.pipe(
    filter((available) => !!available),
  );

  readonly build = build;

  constructor(
    private readonly graphqlApiService: GraphqlApiService,
  ) { }

  /**
   * fragment connextconfig on ConnextConfig { ... }
   */
  async execute(_query: DocumentNode, input: UpdateConfigInConnextInput): Promise<apollo.FetchResult< { updateConfigInConnext: Partial<ConnextConfig> }, Record<string, any>, Record<string, any>>> {
    const client = await this.graphqlClient$.pipe(first()).toPromise();
    if (!client) {
      throw Error('Missing graphql client!');
    }
    return await client?.mutate<{ updateConfigInConnext: Partial<ConnextConfig> }>({ mutation: build(_query, input) });
  }
}
